export default function raise(msg) {
    throw new Error(msg ?? "Unreachable code");
}
//# sourceMappingURL=raise.js.map